export const allChildrenEqualWidth = () => {
    let children = document.querySelectorAll(".children-equal-width");
    if(children) {
        children.forEach(child=>{
            const children = Array.from(child.children);
            let maxWidth = 0;
            children.forEach(child => {
            const childWidth = child.offsetWidth;
            if (childWidth > maxWidth) {
                maxWidth = childWidth;
            } 
            });
     
            // Set the width of all children to the widest child's width
            children.forEach(child => {
            child.style.width = maxWidth + 'px';
            });
        })
    }
   
}